import { render } from "./BrandOverviewView.vue?vue&type=template&id=abcf41fc"
import script from "./BrandOverviewView.vue?vue&type=script&lang=js"
export * from "./BrandOverviewView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/BrandOverviewView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "abcf41fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('abcf41fc', __exports__)) {
    api.reload('abcf41fc', __exports__)
  }
  
  module.hot.accept("./BrandOverviewView.vue?vue&type=template&id=abcf41fc", () => {
    api.rerender('abcf41fc', render)
  })

}


export default __exports__